var map = {
	"./annotation.jpg": 117,
	"./areachart.pdf": 118,
	"./areahue.jpg": 119,
	"./areasaturation.jpg": 120,
	"./areasize.jpg": 121,
	"./barhue.jpg": 122,
	"./barsaturation.jpg": 123,
	"./barsize.jpg": 124,
	"./circular.jpg": 125,
	"./datafiles/linechart": 50,
	"./datafiles/linechart.json": 50,
	"./dotplot.jpg": 126,
	"./evaluationstimuli/stimuli": 18,
	"./evaluationstimuli/stimuli.json": 18,
	"./input": 51,
	"./input.json": 51,
	"./interconnection_between.png": 44,
	"./interconnection_none.png": 43,
	"./linear.jpg": 127,
	"./linechart.jpg": 128,
	"./multifeature.jpeg": 129,
	"./multifeatures.png": 130,
	"./multipleattributes.png": 131,
	"./multiplefeatures.png": 132,
	"./multipleroi 2.png": 133,
	"./multipleroi.jpeg": 134,
	"./multipleroi.png": 135,
	"./multiplesequences.png": 136,
	"./multisequences.jpeg": 137,
	"./multisequences.png": 138,
	"./pointcontiguous.png": 48,
	"./pointsparse.png": 45,
	"./segmentcontiguous.png": 46,
	"./segmentsparse.png": 47,
	"./singleroi 2.png": 139,
	"./singleroi.jpeg": 140,
	"./singleroi.png": 141,
	"./summarize.png": 142,
	"./test.png": 143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;